import { Divider, Modal } from 'antd';
import close from '../../../../assets/RoundedClose.svg';
import { StarIcon } from './icons';
import Visit from '../../../../assets/Visit.svg';
import messageGrey from '../../../../assets/messageGrey.svg';
import { SupplierScoreBreakdownPanel } from './SupplierScoreBreakdownPanel';

import './index.scss';

export const ViewSupplierDataModal = ({ openModal, setOpen, item, supplierListPosition }: any) => {
    const addedByBuyer = item.added_by_bayer;

    return (
        <Modal
            className="ViewSupplierDataModal"
            destroyOnClose
            centered
            open={openModal}
            closeIcon={<img src={close} onClick={() => setOpen(false)} />}
            footer={false}
            width="80vw"
        >
            <div className="modal">
                <div className="modal__header meeting" style={{ height: '110px' }}>
                    <div className="modal__title">
                        <div className="supplier-card__badge-wrapper">
                            {addedByBuyer && <div className="supplier-card__added">Added by buyer</div>}
                            {item.incumbent && <div className="supplier-card__badge">Incumbent Supplier</div>}
                        </div>
                        <div>{item.name}</div>
                    </div>
                </div>

                <div className="modal__main main" style={{ padding: '24px' }}>
                    <div className="view-supp-modal">
                        <div className="view-supp-modal__column">
                            <SupplierScoreBreakdownPanel
                                item={item}
                                variant="modal"
                                supplierListPosition={supplierListPosition}
                            />
                        </div>
                        <div className="view-supp-modal__column">
                            <div className="company-card">
                                <div className="company-stats">
                                    <div className="stat">
                                        <span className="stat__label">B-BBEE</span>
                                        <span className="stat__value">{item.b_bbee}</span>
                                    </div>
                                    <div className="stat">
                                        <span className="stat__label">Annual Revenue</span>
                                        <span className="stat__value">{item.annual_revenue}</span>
                                    </div>
                                    <div className="stat">
                                        <span className="stat__label">Number of Employees</span>
                                        <span className="stat__value">{item.employees_number}</span>
                                    </div>
                                </div>

                                <a href={item.website} target="_blank" rel="noreferrer">
                                    <div className="visit-btn">
                                        Visit Website <img src={Visit} />
                                    </div>
                                </a>
                            </div>
                            {item.conflict_of_interest && (
                                <>
                                    <Divider />
                                    <div className="conflict">
                                        <span>Potential conflict of interest</span>
                                        <div className="conflict-box">
                                            <img src={messageGrey} />
                                            <div className="content">{item.conflict_of_interest}</div>
                                        </div>
                                    </div>
                                </>
                            )}

                            <Divider />
                            <div className="conflict">
                                <span>References:</span>
                                {item.references?.map((elem: any) => {
                                    return (
                                        <div className="school-card">
                                            <div className="school-card__header">
                                                <div className="school-card__name">{elem.entity_name}</div>
                                                {elem.rating && (
                                                    <div className="school-card__rating">
                                                        {StarIcon} <div>{elem.rating}</div>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="school-card__info">
                                                <div className="school-card__person">{elem.contact_name}</div>
                                                <div className="school-card__contacts">
                                                    <div className="school-card__email">{elem.email}</div>
                                                    <div className="school-card__phone">{elem.phone_number}</div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
